import React, { lazy, Suspense, useEffect, useState } from "react";
import Cookies from "js-cookie";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
// import TradeBehaviorChart from "../component/TradeBehaviorChart";
// import DepositWithdrawalChart from "../component/DepositWithdrawalChart";
import { useHandleError } from "../hooks/useHandleError";
import axios from "axios";
import { BASE_URL, REFERRAL_BASE_URL } from "../api";
import { fetchRealAccounts } from "../hooks/useRealAccounts";
import { getApiHeaders } from "../utils/helpers";
import Loader from "../component/Loader";
import { WebSocketDemo } from "../component/WebSocketDemo";
import { getAuthToken } from "../token";
import MessageToster from "../component/MessageToster";
import { closeModal } from "../utils/modal";
import copy from "copy-to-clipboard";
import { useUser } from "../context/UserContext";
import { Link, useNavigate } from "react-router-dom";

const TradeBehaviorChart = lazy(() => import("../component/TradeBehaviorChart"));
const DepositWithdrawalChart = lazy(() => import("../component/DepositWithdrawalChart"));

export default function Home() {
  const navigate = useNavigate();
  const { userData: contextUserData } = useUser();
  const cookieUserData = JSON.parse(Cookies.get("userdata") || "{}");
  const userData = contextUserData || cookieUserData;
  const rawIbStatus = String(userData?.ibStatus || "").toLowerCase().trim();
  const isIbActive = Number(userData?.isIb) === 1 || ["active", "approve", "approved"].includes(rawIbStatus);
  const isIbPending = rawIbStatus === "pending";
  const isIbRejected = ["reject", "rejected"].includes(rawIbStatus);

  // Text shown in the "IB Status" card, e.g. API "not_applied" -> "Not Applied"
  const ibStatusLabel = isIbActive
    ? "Approved"
    : isIbPending
      ? "Pending"
      : isIbRejected
        ? "Rejected"
        : rawIbStatus
          ? rawIbStatus.replace(/[_-]+/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase())
          : "Not Applied";

  // Used by "Account Overview" to offer a shortcut when something still needs doing
  const isKycApproved = ["approve", "approved", "verified"].includes(String(userData?.kyc_status || "").toLowerCase().trim());
  const isBankAdded = [true, "true", 1].includes(userData?.isBankDetailsAdded);

  const renderKycBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    if (s === "approve" || s === "approved" || s === "verified") {
      return (
        <span className="badge bg-success-subtle text-success border border-success-subtle px-2 py-1 font-size-12">
          <i className="bx bx-check-shield me-1" /> Approved
        </span>
      );
    }
    if (s === "reject" || s === "rejected") {
      return (
        <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-2 py-1 font-size-12">
          <i className="bx bx-x-circle me-1" /> Rejected
        </span>
      );
    }
    return (
      <span className="badge bg-warning-subtle text-warning border border-warning-subtle px-2 py-1 font-size-12">
        <i className="bx bx-time-five me-1" /> {status || "Pending"}
      </span>
    );
  };

  const renderBankDetailsBadge = (isAdded) => {
    const added = isAdded === true || isAdded === "true" || isAdded === 1;
    if (added) {
      return (
        <span className="badge bg-success-subtle text-success border border-success-subtle px-2 py-1 font-size-12">
          <i className="bx bx-check-circle me-1" /> Added
        </span>
      );
    }
    return (
      <span className="badge bg-warning-subtle text-warning border border-warning-subtle px-2 py-1 font-size-12">
        <i className="bx bx-error-circle me-1" /> Not Added
      </span>
    );
  };
  const handleError = useHandleError();
  const [loading, setLoading] = useState(false);
  const [liveAccountCount, setLiveAccountCount] = useState(0);
  const [demoAccountCount, setDemoAccountCount] = useState(0);
  const [mid] = useState(() => sessionStorage.getItem("mid"));
  const [token] = useState(() => getAuthToken());
  const [ibLoading, setIbLoading] = useState(false);
  const [beforeReg, setBeforeReg] = useState(false);
  const [ibTimer, setIbTimer] = useState(0);
  const [ibData, setIbData] = useState({
    email: userData?.email || "",
    fname: "",
    lname: "",
    yearofexp: "",
    companyname: "",
    existclients: "",
    avgvolume: "",
    verifycode: "",
  });
  const [dashboardData, setDashboardData] = useState(null);
  const [ibErrors, setIbErrors] = useState({});
  const totalBal = Number(dashboardData?.in_wallet) - Number(dashboardData?.out_wallet);
  // Shown green when in profit, red when in loss
  const totalProfitLoss = Number(dashboardData?.total_profit_loss) || 0;

  const referralCode = userData?.loginid || userData?.ref_code || userData?.referral_code || "";
  const referralLink = referralCode ? `${REFERRAL_BASE_URL}${referralCode}` : REFERRAL_BASE_URL;

  const copyReferralLink = () => {
    if (!referralLink) return;
    try {
      const success = copy(referralLink);
      if (success) {
        MessageToster("success", `Referral link copied!`);
      } else {
        MessageToster("error", "Failed to copy link");
      }
    } catch {
      MessageToster("error", "Failed to copy link");
    }
  };

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const res = await axios.post(`${BASE_URL}/account/deshbord`, { data: {} }, { headers: getApiHeaders() });
      if (res.data && res.data.code === 200) {
        const item = Array.isArray(res?.data?.data) ? res?.data?.data[0] : res?.data?.data;
        setDashboardData(item || {});
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {

      try {
        if (!mid || !token) return;

        setLoading(true);

        // const inputBody = {};
        // const inputBody = { mid: Number(mid), mode: "" };

        // Demo account count is not shown on the dashboard right now (card replaced by "IB Status").
        // To enable it again: uncomment the demo API call, "demoRes" and the demoRes block below.
        const [liveRes /*, demoRes */] = await Promise.all([
          fetchRealAccounts(),
          // axios.get(`${BASE_URL}/MT5M/demo_account_number_list`, { headers: getApiHeaders() })
        ]);

        if (liveRes.data.code === 200) {
          setLiveAccountCount(liveRes.data.data?.length || 0);
        }

        // if (demoRes.data.code === 200) {
        //   setDemoAccountCount(demoRes.data.data?.length || 0);
        // }

      } catch (error) {
        handleError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, [mid, token]);

  useEffect(() => {
    let interval = null;
    if (ibTimer > 0) {
      interval = setInterval(() => {
        setIbTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [ibTimer]);

  const formatTimer = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const handleIbChange = (e) => {
    const { name, value } = e.target;

    if (name === "avgvolume") {
      if (!/^\d*\.?\d*$/.test(value)) return;
    } else if (["yearofexp", "existclients", "verifycode"].includes(name)) {
      if (!/^\d*$/.test(value)) return;
    }

    setIbData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setIbErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const resetIbForm = () => {
    setIbData({
      email: userData?.email || "",
      fname: "",
      lname: "",
      yearofexp: "",
      companyname: "",
      existclients: "",
      avgvolume: "",
      verifycode: "",
    });
    setIbErrors({});
    setBeforeReg(false);
    setIbTimer(0);
  };

  const validateForm = () => {
    const errors = {};

    // Email validation
    if (!ibData.email || ibData.email.trim() === "") {
      errors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(ibData.email)) {
      errors.email = "Enter valid email";
    }

    // First Name validation
    if (!ibData.fname || ibData.fname.trim() === "") {
      errors.fname = "First name is required";
    } else if (ibData.fname.trim().length < 2) {
      errors.fname = "First name must be at least 2 characters";
    } else if (!/^[a-zA-Z\s.-]+$/.test(ibData.fname)) {
      errors.fname = "First name must contain only letters";
    }

    // Last Name validation
    if (!ibData.lname || ibData.lname.trim() === "") {
      errors.lname = "Last name is required";
    } else if (ibData.lname.trim().length < 2) {
      errors.lname = "Last name must be at least 2 characters";
    } else if (!/^[a-zA-Z\s.-]+$/.test(ibData.lname)) {
      errors.lname = "Last name must contain only letters";
    }

    // Year of Experience validation
    if (!ibData.yearofexp || ibData.yearofexp.toString().trim() === "") {
      errors.yearofexp = "Year of experience is required";
    } else {
      const exp = Number(ibData.yearofexp);
      if (isNaN(exp) || exp < 0 || exp > 80) {
        errors.yearofexp = "Enter a valid year of experience (0-80)";
      }
    }

    // Company Name validation
    if (!ibData.companyname || ibData.companyname.trim() === "") {
      errors.companyname = "Company name is required";
    } else if (ibData.companyname.trim().length < 2) {
      errors.companyname = "Company name must be at least 2 characters";
    }

    // Existing Clients validation
    if (!ibData.existclients || ibData.existclients.toString().trim() === "") {
      errors.existclients = "Existing clients is required";
    } else {
      const clients = Number(ibData.existclients);
      if (isNaN(clients) || clients < 0) {
        errors.existclients = "Existing clients must be a non-negative number";
      }
    }

    // Average Volume validation
    if (!ibData.avgvolume || ibData.avgvolume.toString().trim() === "") {
      errors.avgvolume = "Average volume is required";
    } else {
      const vol = Number(ibData.avgvolume);
      if (isNaN(vol) || vol < 0) {
        errors.avgvolume = "Average volume must be a non-negative number";
      }
    }

    // OTP Verification validation
    if (beforeReg) {
      if (!ibData.verifycode || ibData.verifycode.toString().trim() === "") {
        errors.verifycode = "OTP is required";
      } else if (ibData.verifycode.toString().length !== 6) {
        errors.verifycode = "OTP must be 6 digits";
      } else if (!/^\d+$/.test(ibData.verifycode)) {
        errors.verifycode = "OTP must contain only numbers";
      }
    }

    setIbErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const sendIbOtp = async () => {
    if (!validateForm()) return;
    try {
      setIbLoading(true);
      const body = {
        email: ibData.email,
        otype: "IBREGISTER",
      };
      const res = await axios.post(
        `${BASE_URL}/NEW_IB/before_register`,
        body,
        {
          headers: getApiHeaders(),
        }
      );
      if (res.data.code === 200) {
        MessageToster("success", res.data.message);
        setBeforeReg(true);
        setIbTimer(120);
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setIbLoading(false);
    }
  };

  const resendIbOtp = async () => {
    if (ibTimer > 0 || ibLoading) return;
    try {
      setIbLoading(true);
      const body = {
        email: ibData.email,
        otype: "IBREGISTER",
      };
      const res = await axios.post(
        `${BASE_URL}/NEW_IB/before_register`,
        body,
        {
          headers: getApiHeaders(),
        }
      );
      if (res.data.code === 200) {
        MessageToster("success", res.data.message || "OTP resent successfully");
        setIbTimer(120);
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setIbLoading(false);
    }
  };

  const submitIbForm = async () => {
    if (!validateForm()) return;
    try {
      setIbLoading(true);
      const bodyData = {
        email: ibData.email,
        verifycode: Number(ibData.verifycode),
        fname: ibData.fname,
        lname: ibData.lname,
        yearofexp: ibData.yearofexp,
        companyname: ibData.companyname,
        existclients: ibData.existclients,
        avgvolume: ibData.avgvolume,
      };
      const res = await axios.post(
        `${BASE_URL}/NEW_IB/register`,
        bodyData,
        {
          headers: getApiHeaders(),
        }
      );
      if (res.data.code === 200) {
        MessageToster("success", res.data.message);
        setIbData({
          email: userData?.email || "",
          fname: "",
          lname: "",
          yearofexp: "",
          companyname: "",
          existclients: "",
          avgvolume: "",
          verifycode: "",
        });
        closeModal();
        setIbErrors({});
        setBeforeReg(false);
        setIbTimer(0);
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setIbLoading(false);
    }
  };

  return (
    <>
      <div id="layout-wrapper">
        {loading && <Loader />}
        <Topbar />
        <Sidebar />
        {/* <WebSocketDemo /> */}
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">Dashboard</h2>
                  </div>
                </div>
              </div>
              {/* end page title */}
              {/* Top Row: 5 Main Financial Stats */}
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-5 g-3 mb-4">
                {/* 1. Total Balance */}
                <div className="col">
                  <div className="card athos-stat card-animate overflow-hidden h-100 mb-0">
                    <div className="card-body upcoming-box">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="athos-stat__label mb-0">Total Balance</p>
                          <h2 className="athos-stat__value mt-3 mb-0">
                            <span className="counter-value">
                              {dashboardData?.total_balance !== undefined && dashboardData?.total_balance !== null
                                ? Number(dashboardData.total_balance).toFixed(2)
                                : "0.00"}
                            </span>{" "}
                            <span className="athos-stat__unit">USD</span>
                          </h2>
                        </div>
                        <div className="mini-stat-icon">
                          <div className="avatar-sm upcoming-icon flex-shrink-0">
                            <span className="avatar-title athos-stat__icon rounded-circle fs-2">
                              <i className="bx bx-credit-card font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 2. Total Equity */}
                <div className="col">
                  <div className="card athos-stat card-animate overflow-hidden h-100 mb-0">
                    <div className="card-body upcoming-box">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="athos-stat__label mb-0">Total Equity</p>
                          <h2 className="athos-stat__value mt-3 mb-0">
                            <span className="counter-value">
                              {dashboardData?.total_equity !== undefined && dashboardData?.total_equity !== null
                                ? Number(dashboardData.total_equity).toFixed(2)
                                : "0.00"}
                            </span>{" "}
                            <span className="athos-stat__unit">USD</span>
                          </h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon flex-shrink-0">
                            <span className="avatar-title athos-stat__icon rounded-circle fs-2">
                              <i className="bx bx-doughnut-chart font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 3. Total Deposit */}
                <div className="col">
                  <div className="card athos-stat card-animate overflow-hidden h-100 mb-0">
                    <div className="card-body upcoming-box">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="athos-stat__label mb-0">Total Deposit</p>
                          <h2 className="athos-stat__value mt-3 mb-0">
                            <span className="counter-value">
                              {dashboardData?.total_deposit !== undefined && dashboardData?.total_deposit !== null
                                ? Number(dashboardData.total_deposit).toFixed(2)
                                : "0.00"}
                            </span>{" "}
                            <span className="athos-stat__unit">USD</span>
                          </h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon flex-shrink-0">
                            <span className="avatar-title athos-stat__icon rounded-circle fs-2">
                              <i className="bx bx-down-arrow-circle font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 4. Total Withdraw */}
                <div className="col">
                  <div className="card athos-stat card-animate overflow-hidden h-100 mb-0">
                    <div className="card-body upcoming-box">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="athos-stat__label mb-0">Total Withdraw</p>
                          <h2 className="athos-stat__value mt-3 mb-0">
                            <span className="counter-value">
                              {dashboardData?.total_withdraw !== undefined && dashboardData?.total_withdraw !== null
                                ? Number(dashboardData.total_withdraw).toFixed(2)
                                : "0.00"}
                            </span>{" "}
                            <span className="athos-stat__unit">USD</span>
                          </h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon flex-shrink-0">
                            <span className="avatar-title athos-stat__icon rounded-circle fs-2">
                              <i className="bx bx-up-arrow-circle font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 5. Total Profit/Loss */}
                <div className="col">
                  <div className="card athos-stat card-animate overflow-hidden h-100 mb-0">
                    <div className="card-body upcoming-box">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="athos-stat__label mb-0">Total Profit/Loss</p>
                          <h2 className={`athos-stat__value mt-3 mb-0 ${totalProfitLoss > 0 ? "text-success" : totalProfitLoss < 0 ? "text-danger" : ""}`}>
                            <span className="counter-value">
                              {totalProfitLoss > 0 ? "+" : ""}
                              {totalProfitLoss.toFixed(2)}
                            </span>{" "}
                            <span className="athos-stat__unit">USD</span>
                          </h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon flex-shrink-0">
                            <span className="avatar-title athos-stat__icon rounded-circle fs-2">
                              <i className="bx bx-bar-chart-square font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Row 2: Main Dashboard Content (Left: Wallet & Deposit Chart | Right: Accounts & Become Broker) */}
              <div className="row g-4">
                {/* Left Column: Wallet Summary & Deposit/Withdrawal Chart */}
                <div className="col-xl-4 col-lg-5 col-12">
                  <div className="card mb-4">
                    <div className="card-body">
                      <h4 className="card-title mb-0">Account Overview</h4>
                      <hr className="athos-accent-line athos-overview__line" />
                      <ul className="athos-overview list-unstyled mb-0">
                        <li className="athos-overview__row">
                          <span className="athos-overview__label">
                            <i className="bx bx-check-shield" /> KYC Status
                          </span>
                          <span className="athos-overview__value">
                            {!isKycApproved && (
                              <Link to="/kyc_documents" className="athos-overview__action">Go to KYC</Link>
                            )}
                            {renderKycBadge(userData?.kyc_status)}
                          </span>
                        </li>
                        {/* Bank Details row is hidden while the Bank Details page is switched off
                            (its routes are commented out in App.js). Uncomment both together. */}
                        {/* <li className="athos-overview__row">
                          <span className="athos-overview__label">
                            <i className="bx bxs-bank" /> Bank Details
                          </span>
                          <span className="athos-overview__value">
                            {!isBankAdded && (
                              <Link to="/bank_details" className="athos-overview__action">Add</Link>
                            )}
                            {renderBankDetailsBadge(userData?.isBankDetailsAdded)}
                          </span>
                        </li> */}
                        <li className="athos-overview__row">
                          <span className="athos-overview__label">
                            <i className="bx bx-trending-up" /> Deposit Limit
                          </span>
                          <span className="athos-overview__value">
                            {userData?.deposit_limit !== undefined && userData?.deposit_limit !== null
                              ? Number(userData.deposit_limit).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                              : "0.00"}{" "}
                            <span className="athos-stat__unit">USD</span>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <Suspense fallback={<Loader />}>
                    <DepositWithdrawalChart data={dashboardData} />
                  </Suspense>
                </div>

                {/* Right Column: Account Stats & Become Broker */}
                <div className="col-xl-8 col-lg-7 col-12">
                  {/* Account Overview Cards */}
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="card athos-stat card-animate shadow-none mb-3">
                            <div className="card-body upcoming-box">
                              <div className="d-flex flex-wrap">
                                <div className="me-3">
                                  <p className="athos-stat__label mb-0">Live Account</p>
                                  <h4 className="athos-stat__value athos-stat__value--sm mt-2 mb-0">
                                    {dashboardData?.live_account !== undefined && dashboardData?.live_account !== null
                                      ? dashboardData.live_account
                                      : (liveAccountCount ?? "0")}
                                  </h4>
                                </div>
                                <div className="mini-stat-icon avatar-sm ms-auto">
                                  <div className="avatar-title athos-stat__icon rounded-circle upcoming-icon font-size-20">
                                    <i className="bx bx-bar-chart-square" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card athos-stat card-animate shadow-none mb-0">
                            <div className="card-body upcoming-box">
                              <div className="d-flex flex-wrap">
                                <div className="me-3">
                                  <p className="athos-stat__label mb-0">IB Status</p>
                                  <h4 className="athos-stat__value athos-stat__value--sm mt-2 mb-0">{ibStatusLabel}</h4>
                                </div>
                                <div className="mini-stat-icon avatar-sm ms-auto">
                                  <div className="avatar-title athos-stat__icon rounded-circle upcoming-icon font-size-20">
                                    <i className="bx bx-user-check" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          {/* Income Wallet */}
                          <div className="card athos-stat upcoming-box shadow-none mini-stats-wid mb-3">
                            <div className="card-body">
                              <div className="d-flex flex-wrap">
                                <div className="me-3">
                                  <p className="athos-stat__label mb-0">Income Wallet</p>
                                  <h4 className="athos-stat__value athos-stat__value--sm mt-2 mb-0">
                                    {userData?.commissionwallet !== undefined && userData?.commissionwallet !== null
                                      ? Number(userData.commissionwallet).toFixed(2)
                                      : "0.00"}{" "}
                                    <span className="athos-stat__unit">USD</span>
                                  </h4>
                                </div>
                                <div className="mini-stat-icon avatar-sm ms-auto">
                                  <div className="avatar-title athos-stat__icon rounded-circle upcoming-icon font-size-20">
                                    <i className="bx bx-wallet" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Deposit Wallet */}
                          <div className="card athos-stat upcoming-box shadow-none mini-stats-wid mb-0">
                            <div className="card-body">
                              <div className="d-flex flex-wrap">
                                <div className="me-3">
                                  <p className="athos-stat__label mb-0">Bonus Wallet</p>
                                  <h4 className="athos-stat__value athos-stat__value--sm mt-2 mb-0">
                                    {userData?.bonuswallet !== undefined && userData?.bonuswallet !== null
                                      ? Number(userData.bonuswallet).toFixed(2)
                                      : "0.00"}{" "}
                                    <span className="athos-stat__unit">USD</span>
                                  </h4>
                                </div>
                                <div className="mini-stat-icon avatar-sm ms-auto">
                                  <div className="avatar-title athos-stat__icon rounded-circle upcoming-icon font-size-20">
                                    <i className="bx bx-dollar-circle" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Deposit Wallet
                          <div className="card athos-stat upcoming-box shadow-none mini-stats-wid mb-0">
                            <div className="card-body">
                              <div className="d-flex flex-wrap">
                                <div className="me-3">
                                  <p className="athos-stat__label mb-0">Deposit Wallet</p>
                                  <h4 className="athos-stat__value athos-stat__value--sm mt-2 mb-0">
                                    {userData?.pinwallet !== undefined && userData?.pinwallet !== null
                                      ? Number(userData.pinwallet).toFixed(2)
                                      : "0.00"}{" "}
                                    <span className="athos-stat__unit">USD</span>
                                  </h4>
                                </div>
                                <div className="mini-stat-icon avatar-sm ms-auto">
                                  <div className="avatar-title athos-stat__icon rounded-circle upcoming-icon font-size-20">
                                    <i className="bx bx-dollar-circle" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Become Broker Card */}
                  <div className="card welcome-card">
                    <div className="card-body position-relative">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div className="welcome-card__eyebrow">Introducing Broker Programme</div>
                          <hr className="athos-accent-line" />
                          <h1>{isIbActive ? "Your IB Account" : "Become an Introducing Broker"}</h1>
                          <p>
                            {isIbActive
                              ? "Your IB account is active and verified. Track your clients and commission in the IB dashboard."
                              : isIbPending
                                ? "Your IB application is under review. We will notify you once it is approved."
                                : isIbRejected
                                  ? "Your application was not approved. You can review the details and apply again."
                                  : "Refer clients, follow their activity and earn commission on their trading volume."}
                          </p>
                          <button
                            type="button"
                            className="btn"
                            onClick={() => {
                              if (isIbActive) {
                                navigate("/ib_dashboard");
                              } else {
                                navigate("/become-ib");
                              }
                            }}
                          >
                            {isIbActive
                              ? "IB Dashboard"
                              : isIbPending
                                ? "Pending Approval"
                                : isIbRejected
                                  ? "Re-Apply IB"
                                  : "Become An IB"}
                            <i className="bx bx-right-arrow-alt ms-2 font-size-18 align-middle" />
                          </button>
                        </div>
                        <div className="flex-shrink-0">
                          {/* Brand mark as a quiet watermark */}
                          <img src="/assets/images/logo/athosfx-symbol-dark.png" alt="" aria-hidden="true" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Invite Friends & Earn Card */}
                  <div
                    className="card mt-3 shadow-sm border-0"
                    style={{
                      borderRadius: "14px",
                      border: "1px solid #e9edf2",
                    }}
                  >
                    <div className="card-body p-3 p-md-4">
                      <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="flex-shrink-0 bg-primary-subtle rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              width: "48px",
                              height: "48px",
                              minWidth: "48px",
                            }}
                          >
                            <i
                              className="bx bx-share-alt text-primary"
                              style={{ fontSize: "22px" }}
                            />
                          </div>
                          <div>
                            <h5 className="fw-bold mb-1" style={{ fontSize: "16px" }}>
                              Invite Friends
                            </h5>
                            <p className="text-muted mb-0 font-size-13">
                              Share your referral link to build your team.
                            </p>
                          </div>
                        </div>
                        <div className="input-group w-100" style={{ maxWidth: "440px" }}>
                          <input
                            type="text"
                            className="form-control"
                            readOnly
                            value={referralLink}
                            style={{ fontSize: "13px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center gap-1 px-3 fw-semibold shadow-sm"
                            onClick={copyReferralLink}
                          >
                            <i className="bx bx-copy font-size-16" /> Copy
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* container-fluid */}
          </div>
          <Footer />
        </div>
      </div>
      {/* IB Account Modal - Commented out, now redirected to dedicated /become-ib page
      <div
        className="modal fade bs-example-modal-center"
        tabIndex={-1}
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">IB Account</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetIbForm}
              />
            </div>
            <div className="modal-body">
              <div className="col-12 mb-3">
                <label className="form-label">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={ibData.email}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.email && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.email}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  First Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="First Name"
                  name="fname"
                  value={ibData.fname}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.fname && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.fname}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  Last Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Last Name"
                  name="lname"
                  value={ibData.lname}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.lname && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.lname}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  Year Of Experience
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="yearofexp"
                  placeholder="Year Of Experience"
                  value={ibData.yearofexp}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.yearofexp && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.yearofexp}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  Company Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Company Name"
                  name="companyname"
                  value={ibData.companyname}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.companyname && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.companyname}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  No. Of Existing Client
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="existclients"
                  placeholder="No. Of Existing Client"
                  value={ibData.existclients}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.existclients && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.existclients}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  Average Volume Per Month
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="avgvolume"
                  placeholder="Average Volume Per Month"
                  value={ibData.avgvolume}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.avgvolume && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.avgvolume}</span>
                  </div>
                )}
              </div>

              {beforeReg && (
                <div className="col-12 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <label className="form-label mb-0">
                      Verify OTP <span className="text-danger">*</span>
                    </label>
                    {ibTimer > 0 ? (
                      <span className="text-muted small">
                        Resend in <strong className="text-primary">{formatTimer(ibTimer)}</strong>
                      </span>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-link btn-sm p-0 text-decoration-none fw-semibold"
                        onClick={resendIbOtp}
                        disabled={ibLoading}
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                  <input
                    type="text"
                    maxLength={6}
                    className="form-control"
                    placeholder="Enter OTP"
                    name="verifycode"
                    value={ibData.verifycode}
                    onChange={handleIbChange}
                  />
                  {ibErrors.verifycode && (
                    <div className="text-danger small mt-1 d-flex align-items-center">
                      <i className="bx bx-info-circle me-1 font-size-14"></i>
                      <span>{ibErrors.verifycode}</span>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={resetIbForm}
              >
                Reset
              </button>
              {!beforeReg ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={sendIbOtp}
                  disabled={ibLoading}
                >
                  {ibLoading ? "Sending OTP..." : "Send OTP"}
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={submitIbForm}
                  disabled={ibLoading}
                >
                  {ibLoading ? "Submitting..." : "Submit"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      */}
    </>
  );
}


//  <div className="col-xl-3 col-lg-6 col-sm-6">
//                   <div className="card mini-stats-wid">
//                     <div className="card-body bg-warning-subtle">
//                       <div className="flex-shrink-0 align-self-center pb-3">
//                         <div className="mini-stat-icon avatar-sm rounded-circle bg-primary">
//                           <span className="avatar-title bg-warning">
//                             <i className="bx bx-credit-card font-size-24" />
//                           </span>
//                         </div>
//                       </div>
//                       <div className="row pt-3">
//                         <div className="col-6">
//                           <div>
//                             <h3 className="h3 fw-bold">100.00</h3>
//                             <p className="text-muted text-truncate mb-0">
//                               Total Balance
//                             </p>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div>
//                             <div
//                               id="area-sparkline-chart-1"
//                               data-colors='["--bs-warning"]'
//                               className="apex-charts"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-xl-3 col-lg-6 col-sm-6">
//                   <div className="card mini-stats-wid">
//                     <div className="card-body bg-primary-subtle">
//                       <div className="flex-shrink-0 align-self-center pb-3">
//                         <div className="mini-stat-icon avatar-sm rounded-circle bg-primary">
//                           <span className="avatar-title bg-primary">
//                             <i className="bx bx-doughnut-chart font-size-24" />
//                           </span>
//                         </div>
//                       </div>
//                       <div className="row pt-3">
//                         <div className="col-6">
//                           <div>
//                             <h3 className="h3 fw-bold">100.00</h3>
//                             <p className="text-muted text-truncate mb-0">
//                               Total Equity
//                             </p>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div>
//                             <div
//                               id="area-sparkline-chart-2"
//                               data-colors='["--bs-primary"]'
//                               className="apex-charts"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-xl-3 col-lg-6 col-sm-6">
//                   <div className="card mini-stats-wid">
//                     <div className="card-body bg-info-subtle">
//                       <div className="flex-shrink-0 align-self-center pb-3">
//                         <div className="mini-stat-icon avatar-sm rounded-circle bg-primary">
//                           <span className="avatar-title bg-info">
//                             <i className="bx bx-trending-up font-size-24" />
//                           </span>
//                         </div>
//                       </div>
//                       <div className="row pt-3">
//                         <div className="col-6">
//                           <div>
//                             <h3 className="h3 fw-bold">0.00</h3>
//                             <p className="text-muted text-truncate mb-0">
//                               Total Margin in use{" "}
//                             </p>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div>
//                             <div
//                               id="area-sparkline-chart-3"
//                               data-colors='["--bs-info"]'
//                               className="apex-charts"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-xl-3 col-lg-6 col-sm-6">
//                   <div className="card mini-stats-wid">
//                     <div className="card-body bg-success-subtle">
//                       <div className="flex-shrink-0 align-self-center pb-3">
//                         <div className="mini-stat-icon avatar-sm rounded-circle bg-primary">
//                           <span className="avatar-title bg-success">
//                             <i className="bx bx-dollar-circle font-size-24" />
//                           </span>
//                         </div>
//                       </div>
//                       <div className="row pt-3">
//                         <div className="col-6">
//                           <div>
//                             <h3 className="h3 fw-bold">100.00</h3>
//                             <p className="text-muted text-truncate mb-0">
//                               Total Free Margin
//                             </p>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div>
//                             <div
//                               id="area-sparkline-chart-3"
//                               data-colors='["--bs-success"]'
//                               className="apex-charts"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>